export default "__VITE_ASSET__b948a344__"